module.exports = __webpack_public_path__ + "img/eswatini.f83a9cf8.png";